export default __webpack_public_path__ + "static/media/agustinLemes.85d62ebf.jpg";